export const handleFormInput = (e, payload) => {
    return { ...payload, [e.target.name]: e.target.value };
}

export const handleFormNumericInput = (e, payload) => {
    return { ...payload, [e.target.name]: parseInt(e.target.value) };
}

export const handleFormRadio = (e, payload) => {
    return { ...payload, [e.target.name]: parseInt(e.target.value) };
}

export const handleFormCheckbox = (e, payload) => {
    return { ...payload, [e.target.name]: e.target.checked ? true : false };
}

export const handleFormMultiSelect = (e, payload) => {
    let options = e.target.options, value = [];
    for (let i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) {
            value.push(parseInt(options[i].value));
        }
    }
    return { ...payload, [e.target.name]: value };
}

export const handleTenderFormInput = (index, e, payload) => {
    const nData = payload?.map((item, idx) => {
        if (index === idx) {
            return { ...item, [e.target.name]: e.target.value };
        } else {
            return { ...item }
        }
    })

    return nData
}

export const handleTenderFormInputDate = (index, e, payload) => {
    const nData = payload.map((item, idx) => {
        if (index === idx) {
            return { ...item, [e.target.name]: e.target.value };
        } else {
            return { ...item }
        }
    })

    return nData
}

export const handleTenderFormInputFile = (index, e, payload) => {
    const nData = payload.map((item, idx) => {
        if (index === idx) {
            return { ...item, [e.target.name]: e.target.value };
        } else {
            return { ...item }
        }
    })

    return nData
}
